import { tv } from 'tailwind-variants'

export const overlayVariants = tv({
  base: 'absolute inset-0 transition-opacity z-[20] bg-black/60 backdrop-blur-sm rounded-r-full',
  variants: {
    visible: {
      true: 'opacity-100',
      false: 'opacity-0 pointer-events-none'
    }
  },
  defaultVariants: {
    visible: false
  }
})

export const closeButtonVariants = tv({
  base: 'absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 transition-opacity z-[30]',
  variants: {
    visible: {
      true: 'opacity-100',
      false: 'opacity-0'
    },
    placement: {
      mobile: '',
      desktop: ''
    },
    clickable: {
      true: '',
      false: 'pointer-events-none'
    }
  },
  defaultVariants: {
    visible: false,
    placement: 'mobile',
    clickable: true
  },
  compoundVariants: [
    {
      placement: 'mobile',
      visible: false,
      class: 'pointer-events-none'
    },
    {
      placement: 'desktop',
      visible: false,
      class: 'opacity-0 group-hover:opacity-100'
    }
  ]
})